import { render, staticRenderFns } from "./receiver_select.vue?vue&type=template&id=8210eb0a&scoped=true"
import script from "./receiver_select.vue?vue&type=script&lang=js"
export * from "./receiver_select.vue?vue&type=script&lang=js"
import style0 from "./receiver_select.vue?vue&type=style&index=0&id=8210eb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8210eb0a",
  null
  
)

export default component.exports